import posthog from 'posthog-js';
import { initAnalytics } from '@/tenants/_shared/lib/analytics';

if (typeof window !== 'undefined' && process.env.NEXT_PUBLIC_POSTHOG_KEY) {
  posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY, {
    api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST,
    defaults: '2026-01-30',
    autocapture: false,
    capture_dead_clicks: false,
    capture_heatmaps: false,
    capture_pageleave: false,
    capture_pageview: false,
    capture_performance: false,
    disable_session_recording: true,
    before_send: (event) => {
      if (event?.event === '$exception') {
        const ex = event.properties?.['$exception_list']?.[0];
        const type = ex?.['$exception_type'];
        const message = ex?.['$exception_message'];
        // Drop noisy exceptions that provide no actionable signal
        if (type === 'CustomEvent') return null;
        if (message === 'Script error.') return null;
        if (message === 'fbq is not defined') return null;
      }
      return event ?? null;
    },
  });
}

initAnalytics();
